export enum AuthorizationState {
    Authorized = 'Authorized',
    Requested = 'Requested',
    Pending = 'Pending',
    Declined = 'Declined',
    Canceled = 'Canceled',
}

export enum ChallengeType {
    Show = 'Show',
    Redirect = 'Redirect',
}

export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
}
